module.exports = __webpack_public_path__ + "static/img/SW2.92c438ee.png";